import { createPluralFormatter, formatUSCurrency } from 'helpers/formatHelpers'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { parseCurrency } from 'helpers/formHelpers'
import moment from 'moment'
import { DATE_FORMAT_ISO_FULL, DATE_FORMAT_READABLE, DATE_FORMAT_US } from 'constants/datetime'

export const maskDate = (value: string) => {
  if (!value) {
    return value
  }
  return moment(value, DATE_FORMAT_US).format(DATE_FORMAT_READABLE)
}

export const transformDateBefore = (value: string) => {
  return moment(value).format(DATE_FORMAT_US)
}

export const transformDateAfter = (value: string) => {
  return moment(value, DATE_FORMAT_US).format(DATE_FORMAT_ISO_FULL)
}

export const CURRENCY_MASK = createNumberMask({ prefix: '$' })

export const maskIncome = (value: string) => {
  return formatUSCurrency(value)
}

export const transformIncomeAfter = (value: string) => {
  return `${ parseCurrency(value) || '0' }`
}

const getPluralSeconds = createPluralFormatter('second', 'seconds')

export const getTimeLeftDisplay = (secondsLeft: number | null) => {
  if (!secondsLeft || secondsLeft < 0) {
    return ''
  }

  if (secondsLeft < 60) {
    return `${ secondsLeft } ${ getPluralSeconds(secondsLeft) }`
  }

  return moment.duration(secondsLeft * 1000).humanize()
}
